export const isIOSApp = () =>
  /ZoPoundApp-iOS/.test(navigator.userAgent) || window.Capacitor?.getPlatform?.() === "ios";

export const openOnWebsite = (path = "/") => {
  const url = `${window.location.origin}${path}`;
  const browser = window.Capacitor?.Plugins?.Browser;
  if (browser?.open) return browser.open({ url });
  window.open(url, "_blank", "noopener");
};
